import { Card, Flex, Select, Typography } from "antd";
import React, { useState } from "react";

import FinancialScoreChart from "./FinancialScoreChart";
import PaymentPlansChart from "./PaymentPlansChart";
import AmoutChart from "./AmoutChart";

import arrowDown from "../../../../../assets/icons/arrow-down12.png";
import "../styles.css";

export default function Payments() {
  const [isArrowDown, setIsArrowDown] = useState(true);

  return (
    <Card>
      <Flex vertical gap={30}>
        <Flex vertical gap={15}>
          <Typography.Title level={4} style={{ marginBottom: 0 }}>
            Payments
          </Typography.Title>
          <Select
            className="custom-style-selection-insurance-filter"
            style={{ alignItems: "center" }}
            suffixIcon={<img src={arrowDown} alt="arrow-down" style={{ transform: `rotate(${isArrowDown ? "0" : "180deg"})` }} />}
            placeholder="Select Treatments you want to see details for"
            onOpenChange={() => setIsArrowDown((down) => !down)}
          />
        </Flex>

        <Flex gap={30} justify="space-between" style={{ overflowX: "auto" }} className="custom-scroll">
          <PaymentPlansChart />
          <AmoutChart />
          <FinancialScoreChart />
        </Flex>
      </Flex>
    </Card>
  );
}
